import { createSelector } from '@reduxjs/toolkit';
import { NavQueryParams } from './DeviceLayout';
import { RootState } from '../../../../redux/store.model';
import {
  getGroupIdQueryParam,
  getGroupSelectedByQueryParamSelector,
  getGroups,
} from '../../../../redux/groups/selectors';
import {
  getDeviceIdFromQueryParam,
  getDeviceSelectedName,
} from '../../../../redux/commander/selectors';
import {
  getParamsGenerator,
  inferSubModuleSelected,
  navigationPath,
} from '../../navigations/navigationPath';

const patterns = [
  '/devicemanager/device/:deviceId/group/:groupId/device-detail/:moduleSelected/*',
  '/devicemanager/device/:deviceId/device-detail/:moduleSelected/*',
];

export const getParamsDevice = getParamsGenerator(patterns);
export const getModuleSelectedDevice = (pathname: string) =>
  getParamsDevice(pathname).moduleSelected ?? '';

const dicTitles: Record<string, string> = {
  history: 'device.monitoring.title',
  incidents: 'incident_manager.title',
  settings: 'device.edit',
  alarms: 'incident.all_alarms',
};

const getProps = (_: RootState, props: NavQueryParams) => props;

export const getDeviceSectionsNavigationSelector = createSelector(
  [
    getProps,
    getGroupIdQueryParam,
    getDeviceIdFromQueryParam,
    getGroups,
    getGroupSelectedByQueryParamSelector,
    getDeviceSelectedName,
  ],
  (props, groupId, deviceId, groups, group, deviceName) => {
    const url = groupId
      ? `/devicemanager/device/${deviceId}/group/${groupId}/device-detail/`
      : `/devicemanager/device/${deviceId}/device-detail/`;
    const navigators = navigationPath(props, groupId, group).concat([
      {
        content: deviceName || '...',
        href: url,
      },
    ]);
    /** module selected */
    const { polyglot } = props;
    const { pathname } = window.location;
    const moduleSelected = getModuleSelectedDevice(pathname);

    if (moduleSelected) {
      navigators.push({
        content: polyglot.t(dicTitles[moduleSelected] ?? ''),
        href: `${url}${moduleSelected}`,
      });
    }
    const subModules = inferSubModuleSelected(getParamsDevice(pathname));
    navigators.push(...subModules);

    return navigators;
  }
);
